import Vue from "vue";
import Router from "vue-router";
import pagesConfig from "./pages.config.json";
import * as pagesComponents from "./pages.components";

Vue.use(Router);

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
const originalReplace = Router.prototype.replace;
Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch((err) => err);
};
const createAnRoute = (item) => {
  let anRoute = {
    path: item.path,
    name: item.name || "",
    meta: item.meta || "",
    redirect: item.redirect || "",
    component: pagesComponents[item.component],
  };
  if (item.children && item.children.length > 0) {
    anRoute.children = item.children.map((child) => {
      return createAnRoute(child);
    });
  }
  return anRoute;
};

const registerRoute = (config) => {
  let route = [];
  config.forEach((page) => {
    route.push(createAnRoute(page));
  });
  return route;
};

const routes = registerRoute(pagesConfig);
routes.push({
  path: "*",
  redirect: "/404",
});
export default new Router({
  mode: "history",
  base: "/",
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes,
});
